import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yzm",
  "use": "icon-yzm-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yzm\"><defs><style></style></defs><path d=\"M835.1 200.9c-7.7.3-15.3.4-22.7.4-194.9 0-280.9-82.6-281.6-83.3l-19.4-19.7-19.6 19.7c-.8.9-85 83.3-281.5 83.3-7.4 0-15-.1-22.7-.4l-27.4-.9v374.4c0 98 35.4 241 341.6 350.4l9.6 3.4 9.6-3.4c306.2-109.4 341.6-252.4 341.6-350.4V200l-27.5.9M481.2 671.2L304.8 517.6l46.8-37.3 93.8 68S574.9 416.6 700 355l17.9 19.8S561.6 502.2 481.2 671.2m0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol